/* eslint-disable @typescript-eslint/ban-types */
import { createReducer, createAction } from '@reduxjs/toolkit'
import { ListEstimate } from '../types/index'

type SortOrder = 'asc' | 'desc'

export type EstimatesSortType =
  | { created_at: SortOrder }
  | { full_name: SortOrder }
  | { email: SortOrder }
  | { status: SortOrder }
  | { zip_from: SortOrder }
  | { zip_to: SortOrder }

export interface EstimatesSearchPayload {
  email: string
  date_min: string
  date_max: string
  phone: string
  status: string
  city: string
  zip: string
}

export interface EstimatesReducer {
  estimates: ListEstimate[]
  total_pages: number
  total_count: number
  currentPage: number
  sort: EstimatesSortType
  search: EstimatesSearchPayload
}

const initialState: EstimatesReducer = {
  estimates: [],
  total_pages: 0,
  total_count: 0,
  currentPage: 1,
  sort: { created_at: 'desc' },
  search: {
    email: '',
    date_min: '',
    date_max: '',
    phone: '',
    status: '',
    city: '',
    zip: ''
  }
}

export const FETCH_ESTIMATES = createAction('estimates_reducer/fetch_estimates')
interface FetchEstimatesSuccessPayload {
  total_pages: number
  total_count: number
  estimates: ListEstimate[]
}
export const FETCH_ESTIMATES_SUCCESS = createAction<FetchEstimatesSuccessPayload>(
  'estimates_reducer/fetch_estimates_success'
)
export const FETCH_ESTIMATES_FAIL = createAction('estimates_reducer/fetch_estimates_fail')

export const NEXT_PAGE = createAction('estimates_reducer/next_page')
export const PREVIOUS_PAGE = createAction('estimates_reducer/previous_page')
interface SetPagePayload {
  page: number
}
export const SET_PAGE = createAction<SetPagePayload>('estimates_reducer/set_page')
export const SET_SORT = createAction<EstimatesSortType>('estimates_reducer/set_sort')
export const SET_SEARCH = createAction<EstimatesSearchPayload>('estimates_reducer/set_search')

export const estimatesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(FETCH_ESTIMATES_SUCCESS, (state, action) => {
      return { ...state, ...action.payload }
    })
    .addCase(NEXT_PAGE, (state) => {
      if (state.currentPage >= state.total_pages) {
        return state
      }
      return { ...state, currentPage: state.currentPage + 1 }
    })
    .addCase(PREVIOUS_PAGE, (state) => {
      if (state.currentPage === 1) {
        return state
      }
      return { ...state, currentPage: state.currentPage - 1 }
    })
    .addCase(SET_PAGE, (state, action) => {
      return { ...state, currentPage: action.payload.page }
    })
    .addCase(SET_SORT, (state, action) => {
      return { ...state, sort: action.payload }
    })
    .addCase(SET_SEARCH, (state, action) => {
      return { ...state, search: action.payload }
    })
})

export default estimatesReducer
